import {
  Grid,
  CardMedia,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box,
  Alert
} from '@mui/material'

const fileInputIntegrations = [
  {
    id: 'csv_file',
    title: 'CSV file upload',
    logo: 'csv'
  },
  {
    id: 'excel_file',
    title: 'Excel file upload',
    logo: 'excel'
  }
]

const FeatureIntegrations = [
  { id: 'google_sheets', title: 'Google Sheets', logo: 'google-sheets' },
  { id: 'microsoft_excel', title: 'Microsoft Excel', logo: 'microsoft-excel' },
  { id: 'shopify', title: 'Shopify', logo: 'shopify' },
  { id: 'stripe', title: 'Stripe', logo: 'stripe' },
  { id: 'xero', title: 'Xero', logo: 'xero' },
  { id: 'hubspot', title: 'Hubspot', logo: 'hubspot' },
  { id: 'quickbooks', title: 'Quickbooks', logo: 'quickbooks' },
  { id: 'square', title: 'Square', logo: 'square' }
]

export const MapIntegrations = (props) => {
  const { onSupportIntegrationClick, onIntegrationClick } = props
  return (
    <Grid
      container
      spacing={1}
    >
      {fileInputIntegrations.map((integration) => (
        <IntegrationCard
          key={integration.id}
          handleOnClick={onSupportIntegrationClick}
          {...integration}
        />
      ))}
      {FeatureIntegrations.map((integration) => (
        <IntegrationCard
          key={integration.id}
          handleOnClick={onIntegrationClick}
          {...integration}
        />
      ))}
    </Grid>
  )
}

const IntegrationCard = (props) => {
  const { id, logo, title, handleOnClick } = props
  return (
    <Grid
      item
      xs={6}
    >
      <Card sx={{ display: 'flex', height: '3rem', borderRadius: 0 }}>
        <CardActionArea
          onClick={() => handleOnClick(title, id)}
          sx={{
            height: '100%',
            '&:hover': {
              backgroundColor: 'action.selectedHover'
            },
            display: 'flex',
            direction: 'row',
            justifyContent: 'flex-start',
            p: 1
          }}
        >
          <CardMedia
            component='img'
            sx={{ width: 32 }}
            image={`${process.env.NEXT_PUBLIC_MS_ASSETS_URL}/public/logos/${logo}.png`}
            alt={`${title} logo`}
          />
          <CardContent>
            <Typography>{title}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  )
}

export const IntegrationComingSoon = (props) => {
  const { integration } = props
  return (
    <Box
      component={Alert}
      severity='warning'
      icon={false}
    >
      <Typography
        variant='h6'
        sx={{ mb: 1 }}
      >
        {integration} is coming soon!
      </Typography>
      <Typography variant='body2'>
        In the mean time export your address data as a CSV and upload using the
        box below.
      </Typography>
    </Box>
  )
}
